<template>
    <f7-page
        :class="`explore explore-scroll withHalfBg ${exploreCardOpen ? 'exploreCardOpen' : ''}`"
        name="Explore"
        no-swipeback
        no-navbar
    >
        <div style="position: relative">
            <f7-link
                icon-only
                style="position: absolute; top: 10px; padding: 0 16px; right: 0px; font-size: 30px; color: #999999"
                icon="ion-search"
                href="/search"
            />
        </div>
        <div class="explore-top">
            <f7-block>
                <h1 style="margin: 0px 0 2px 0; text-align: left">{{ user.username ? `Hey ${user.username}!` : 'Hi there!' }}</h1>
                <div style="text-align: left">Choose what's next</div>
            </f7-block>
            <f7-block
                style="margin-bottom: 0px"
                class="nowide"
            >
                <f7-toolbar
                    tabbar
                    labels
                    class="exploreTabbar"
                >
                    <a
                        href="/explore/"
                        class="tab-link tab-link-active"
                        data-route-tab-id="tab-1"
                    ><span class="">Learn<br>•</span></a>
                    <a
                        href="/explore/play"
                        class="tab-link"
                        data-route-tab-id="tab-3"
                    ><span class="">{{ play }}<br>•</span></a>
                    <a
                        href="/explore/listen"
                        class="tab-link"
                        data-route-tab-id="tab-2"
                    ><span class="">Listen<br>•</span></a>
                    <a
                        href="/explore/ask"
                        class="tab-link"
                        data-route-tab-id="tab-4"
                    ><span class="">{{ ask }}<br>•</span></a>
                </f7-toolbar>
            </f7-block>
        </div>
        <div class="exploreContentSectionWave" />
        <f7-tabs
            routable
            class="tabsContentSection"
        >
            <f7-tab
                id="tab-1"
                tab-active
            />
            <f7-tab id="tab-2" />
            <f7-tab id="tab-3" />
            <f7-tab id="tab-4" />
            <f7-tab id="tab-5" />
        </f7-tabs>

        <br><br>
        <app-tabbar tab="explore" />
    </f7-page>
</template>

<script>
import AppTabbar from '../components/appTabbar.vue';

export default {
    store: ['api', 'user', 'exploreCardOpen'],
    components: {
        AppTabbar
    },
    data () {
        return {
            play: 'Play',
            ask: 'Ask',
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        }
    },

    created: function () { },
    mounted: function () {
        this.variant = parseFloat(localStore.getItem(`experiment-016_explore-names`));
        if (this.variant === 1) {
            this.play = 'Exercise';
        }
        if (this.variant === 2) {
            this.ask = 'Discuss';
        }
    },
    beforeDestroy: function () { },
    methods: {}
};
</script>
<style lang="less" scoped>
@import '../css/colors.less';

.icon {
    border-radius: 50%;
    height: 50px;
    width: 50px;
    line-height: 50px;
    display: inline-block;
    color: @green;
    // border: 1px solid @darkGreen;
}
.explore-top {
    padding-top: 16px;
    margin-top: 20px;
}
.exploreContentSectionWave {
    padding-top: 20px;
    width: 100%;
    min-height: 100px;
    max-width: 100vw;
    overflow-x: hidden;
    background-color: @darkBackground;
    background-image: url('../img/0.4/bgwave.png');
    // background-size: 307px 11px;
    background-size: 460.5px 16.5px;
    background-position: top left;
    background-repeat: repeat-x;
}
.tabsContentSection {
    min-height: 80vh;
    width: 100%;
    background-color: @darkBackground;
    margin-top: -100px;
    position: relative;
    z-index: 1;
}
.theme-dark {
    .exploreContentSectionWave {
        background-color: #1c1c1d;
        background-image: url('../img/0.4/bgwavedark.png');
    }
    .tabsContentSection {
        background-color: #1c1c1d;
    }
}
#explore-shape {
    width: 243px;
    height: 166.5px;
    position: absolute;
    top: 10px;
    right: 0px;
}
</style>
